import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { setContentManagerFilterSectionsReset, setContentManagerSearchFilterType } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { toggleReload } from "../../../src/taskpane/redux/modules/reload";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { FilterDismiss20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/FilterDismiss20Regular";
import { preselectFilterStore } from "../hooks/preselectFilterStore";

export function useMenuItem_ClearFilter(waitFor: boolean) {
  const languageStrings = React.useContext(LanguageContext);
  const dispatch = useDispatch();

  const filterSections = useSelector((state: RootState) => state.contentManagerDirectory?.filterSections);
  const searchValue = useSelector((state: RootState) => state.contentManagerDirectory?.searchValue);
  const currentDirectoryId = useSelector((state: RootState) => state.workingDirectories?.workingDirectories?.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1]?.id : undefined);

  const onClearFilter = React.useCallback(() => {
    // Cancel an in-flight deep-link reconcile: its abandon gate checks
    // isConsumed(), so a late re-publish cannot resurrect the selections this
    // clear just removed. (The reducer drops the pending flag.)
    // Directory-scoped: a reconcile can only be in flight for THIS directory,
    // and an unconsumed deep link bound elsewhere must survive a clear here.
    preselectFilterStore.abandonPendingDeepLink(currentDirectoryId);
    dispatch(setContentManagerFilterSectionsReset());
    dispatch(setContentManagerSearchFilterType(""));
    dispatch(toggleReload());
  }, [dispatch, currentDirectoryId]);

  const menuItem_ClearFilter = React.useMemo(() => {

    const isMetadataOrDateFilterActive = filterSections?.some(section =>
      section.items?.some(item => item.selected === true) ||
      section.daysOffset ||
      section.daysOffset === 0
    );

    const isSearchFilterTypeActive = searchValue && !searchValue.value && searchValue.filterType !== "";

    const isFilterSelected = isMetadataOrDateFilterActive || isSearchFilterTypeActive;

    if (isFilterSelected) {
      return {
        key: "clearFilter",
        text: languageStrings.ClearFilter,
        disabled: waitFor === true,
        // iconProps: { iconName: "ClearFilter" },
        iconProps: {},
        onRenderIcon: () => <FilterDismiss20Regular className={menuItemIconStyles} />,
        onClick: onClearFilter,
      } as IContextualMenuItem;
    }

    return null;

  }, [
    filterSections,
    searchValue,
    waitFor,
    languageStrings,
    onClearFilter
  ]);

  return {
    menuItem_ClearFilter
  };
}